import clsx from 'clsx';

import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  className?: string;
}

class ConsumerBorderCard extends PureBaseComponent<Props> {
  render() {
    const { children, className } = this.props;

    const completeClassname = clsx('ConsumerBorderCard', className);

    return <div className={completeClassname}>{children}</div>;
  }
}

export default ConsumerBorderCard;
